export default function Services() {

  const items = [
    { img: '1-account-management.svg',
      title: 'Comprehensive account management',
      description: "Includes Amazon promotion strategy, setting up and running ads, creating and optimizing listings, pricing, competitors analysis, and daily monitoring of your account for achieving an increase in sales and profits."
    },
    { img: '2-amazon-advertising.svg',
      title: 'Amazon advertising',
      description: "Our experts will develop an advertising strategy tailored precisely to your Amazon business. That includes the development and management of advertising campaigns, the selection of keywords, the launch of detailed Amazon advertising, as well as the setting up of Google Ads and Facebook Ads."
    },
    { img: '3-market-research.svg',
      title: 'Market research and product search',
      description: "Want to start earning from Amazon sales? Are your products not being bought? We will analyze the market and help you find the right products with high margins and demand that will bring you a decent profit."
    },
    { img: '4-account-audit.svg',
      title: 'Comprehensive account audit',
      description: "Based on the experience of our consultants, you will learn what works and what exactly is missing in your account. We will analyze your business on Amazon and provide a complete list of actions for a flourishing increase in sales."
    },
    { img: '5-creation-listings.svg',
      title: 'Creation and optimization of the listings',
      description: "Creation and optimization of product listings, including corresponding descriptions of what sells, selecting proper keywords, implementing effective titles, bullets, and A+ content for high conversion, and indexing based on the maximum number of keywords."
    },
    { img: '6-selling-products.svg',
      title: 'Selling your products',
      description: "We will register and set up a new account for your products to start selling on Amazon or launch your products with our existing accounts that have hundreds of positive reviews."
    },
    { img: '7-marketing-strategy.svg',
      title: 'Development of a marketing strategy',
      description: "Includes: analysis of the competitive environment, target audience, recommendations for creating and improving listings, advertising strategy, effective pricing, implementation of promotions and discounts to attract more attention of potential buyers and stimulate sales."
    },
    { img: '8-visual-design.svg',
      title: 'Professional visual design',
      description: "We will create a tempting visual funnel to attract more customers to your listings. High quality photo content and 3D modeling - the right visual design will help to outstand your products above competitor's and make them more appealing to the customer."
    },
    { img: '9-starting-business.svg',
      title: 'Starting a business on Amazon',
      description: "Are you considering your own business on Amazon, and don't know how to start? Contact us! We will guide you step by step from market and competitor analysis, marketing strategy development, account registration, listing creation and optimization, stock management, pricing, and advertising administration, from training and consulting to profit reporting."
    }
  ];

  return (
    <section id="services" className="block block-services">
      <div className="container text-center">
        <h2 className="fw-bold">Our Services</h2>
        <div className="row g-4">
          {items.map((item, index) => (
            <div className="col-12 col-sm-6 col-lg-4 mt-2" key={index}>
              <div className="service text-center">
                  <div className="img">
                    <img src={'images/services/'+item.img} alt=""/>
                  </div>
                  <h4 className="title fw-bold">{item.title}</h4>
                  <div className="description text-start">
                    {item.description}
                  </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
